export default "__VITE_ASSET__e37c4efc__"